<template>
  <interview-layout :touch-and-validate="touchAndValidate" :show-help-button="true">
    <div>
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">Hulp bij het financieren</h1>
      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
            <!-- Kortere vraag -->
            <base-input
                type="radiobuttons"
                :options="yesNoOptions"
                name="WantHelpFinancing"
                v-model:value="lead.financing.wantHelpFinancing"
                >
                Wilt u hulp bij het financieren van de maatregelen?
            </base-input>
          </base-form>
        </base-card>
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.financing.wantHelpFinancing.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseForm from "@/components/BaseForm.vue";
import BaseInput from "@/components/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import ButtonRow from "@/components/ButtonRow.vue";
// import CheckmarkItem from "@/components/CheckmarkItem.vue";
import { FlowService } from "@/services/FlowService";
import { useAllStores } from "@/helpers/UseAllStores";

export default {
  components: {
    InterviewLayout,
    BaseCard,
    BaseForm,
    BaseInput,
    BaseButton,
    ButtonRow,
    // CheckmarkItem
  },
  setup() {
    return { ...useAllStores() };
  },
  data() {
    return {
      yesNoOptions: [
        { label: 'Ja', value: true },
        { label: 'Nee', value: false },
      ],
    };
  },
  computed: {
    hasAdviesAccess() {
      return FlowService.getAllowedSection(this.$route.query.section) === 'advies';
    },
  },
  methods: {
    touchAndValidate() {
      this.v$.financing.wantHelpFinancing.$touch();
      return !this.v$.financing.wantHelpFinancing.$invalid;
    },
    onSubmit() {
      if (this.touchAndValidate()) {
        FlowService.pushNext(this);
      }
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
};
</script>

<style lang="scss">
</style>